(function (global) {
  var TOKEN_COOKIE = "amg_customer_token";
  var PROFILE_COOKIE = "amg_customer_profile";

  function readCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie.split(";");
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) !== 0) continue;
      try {
        return decodeURIComponent(part.slice(prefix.length));
      } catch (e) {
        return part.slice(prefix.length);
      }
    }
    return null;
  }

  function readProfile() {
    var raw = readCookie(PROFILE_COOKIE);
    if (!raw) return null;
    try {
      var profile = JSON.parse(raw);
      if (!profile || !profile.id) return null;
      profile.id = normalizeCustomerId(profile.id);
      return profile;
    } catch (e) {
      return null;
    }
  }

  function normalizeCustomerId(id) {
    if (id == null || id === "") return null;
    var value = String(id).trim();
    if (!value) return null;
    if (value.indexOf("gid://") === 0) return value;
    if (/^\d+$/.test(value)) {
      return "gid://shopify/Customer/" + value;
    }
    return value;
  }

  function extractNumericId(id) {
    var normalized = normalizeCustomerId(id);
    if (!normalized) return null;
    if (normalized.indexOf("/") !== -1) {
      return normalized.split("/").pop() || null;
    }
    return normalized;
  }

  function getId() {
    var profile = readProfile();
    return profile ? normalizeCustomerId(profile.id) : null;
  }

  function getNumericId() {
    return extractNumericId(getId());
  }

  function getEmail() {
    var profile = readProfile();
    return profile && profile.email ? profile.email : null;
  }

  function getToken() {
    var token = readCookie(TOKEN_COOKIE);
    return token && token.length ? token : null;
  }

  function isLoggedIn() {
    return !!readProfile();
  }

  function getContext() {
    var profile = readProfile();
    var id = profile ? normalizeCustomerId(profile.id) : null;
    return {
      id: id,
      numericId: id ? extractNumericId(id) : null,
      email: profile ? profile.email || null : null,
      firstName: profile ? profile.firstName || null : null,
      lastName: profile ? profile.lastName || null : null,
      initials: profile ? profile.initials || null : null,
      profile: profile,
      hasToken: !!getToken(),
    };
  }

  global.AMGCustomer = {
    readCookie: readCookie,
    readProfile: readProfile,
    getProfile: readProfile,
    getId: getId,
    getNumericId: getNumericId,
    getEmail: getEmail,
    getToken: getToken,
    isLoggedIn: isLoggedIn,
    getContext: getContext,
    normalizeCustomerId: normalizeCustomerId,
    extractNumericId: extractNumericId,
    TOKEN_COOKIE: TOKEN_COOKIE,
    PROFILE_COOKIE: PROFILE_COOKIE,
  };
})(window);
